$(function() {
    $('.btn-toggle-menu').click(function(e) {

        $(this).toggleClass('active');
        
        $('.main-pc').slideToggle();
    });
});